import React, { useLayoutEffect } from "react";
import { ReactComponent as CloseIcon } from "common/assets/icons/x.svg";

interface PdfViewerProps {
	fileUrl: string | any;
	isOpen: boolean;
	onClose: () => void;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ fileUrl, isOpen, onClose }) => {
	useLayoutEffect(() => {
		if (isOpen) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.removeProperty("overflow");
		}
	}, [isOpen]);

	const handleContainerClick = (event: React.MouseEvent<HTMLDivElement>) => {
		event.stopPropagation();
	};

	if (!isOpen) {
		return null;
	}

	return (
		<div
			className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50"
			onClick={onClose}
		>
			<div
				className="relative w-full h-full max-w-4xl md:h-auto"
				onClick={handleContainerClick}
			>
				<CloseIcon
					onClick={onClose}
					className="absolute cursor-pointer top-4 right-1"
				/>
				<iframe
					src={fileUrl}
					title="PDF Viewer"
					className="w-full h-full border-none md:rounded-lg"
					style={{ minHeight: "95vh" }}
				/>
			</div>
		</div>
	);
};

export default PdfViewer;
